import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  formTitleWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    marginBottom: '2rem',
    padding: '1rem',
  },
  formTitle: {
    fontSize: '2.4rem',
    textAlign: 'center',
  },
};
const createStyles = createUseStyles(styles);

export { createStyles };
